import React from "react";
import Pages_Coming_Soon from "../../../OpenAccess/ComingSoon/Pages_Coming_Soon";

const Vppa = () => {
  return <Pages_Coming_Soon />;
};

export default Vppa;
